import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "email", "passkeyButton"]

  connect() {
    this.validate()
  }

  validate() {
    const hasName = this.nameTarget.value.trim().length > 0
    const hasEmail = this.emailTarget.value.trim().length > 0
    this.passkeyButtonTarget.disabled = !(hasName && hasEmail)
  }
}
